export default __webpack_public_path__ + "static/media/TestAssign2.216ae23d.png";